import { createSelector } from 'reselect';

export interface ManagersState {
  managers: any[];
  loading: boolean;
  editManager: any;
}

export const initialState: ManagersState = {
  managers: [],
  loading: false,
  editManager: null,
};

const getManagers = ({ managers }: any): ManagersState => managers;

export const managersSelectors = {
  getManagers: createSelector(
    getManagers,
    ({ managers }) => managers,
  ),

  getLoading: createSelector(
    getManagers,
    ({ loading }) => loading,
  ),

  getEditManageer: createSelector(
    getManagers,
    ({ editManager }) => editManager,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/selectors.ts